import { Injectable } from '@angular/core';
import { SELECTORS } from '@root/app.config';

@Injectable({
	providedIn: 'root',
})
export class ScrollService {
	constructor() {}

	scrollToTop(behavior: ScrollBehavior = 'smooth'): void {
		window.scrollTo({ top: 0, behavior });
	}

	async scrollToTopAsync(): Promise<void> {
		return new Promise((resolve) => {
			this.scrollToTop();

			const checkScrollPosition = () => {
				const currentScroll = window.scrollY || document.documentElement.scrollTop;

				if (currentScroll === 0) {
					resolve();
				} else {
					requestAnimationFrame(checkScrollPosition);
				}
			};

			requestAnimationFrame(checkScrollPosition);
		});
	}

	scrollToFormError(event: Event): void {
		const element = event.currentTarget as HTMLElement;
		const form = element.closest('form') as HTMLElement;
		const firstInvalidBlock = form.querySelector(SELECTORS.form_invalid_element) as HTMLElement;
		let elementToScroll: HTMLElement;

		if (firstInvalidBlock?.parentElement) {
			elementToScroll = this.willChildBeVisible(firstInvalidBlock.parentElement, firstInvalidBlock)
				? firstInvalidBlock?.parentElement
				: firstInvalidBlock;
		} else {
			elementToScroll = firstInvalidBlock;
		}

		if (elementToScroll) {
			this.scrollToElement(elementToScroll);
		}
	}

	private willChildBeVisible(parent: HTMLElement, child: HTMLElement): boolean {
		const rect = child.getBoundingClientRect();
		const parentRect = parent.getBoundingClientRect();
		return Math.abs(rect.top) + window.innerHeight > Math.abs(parentRect.top);
	}

	scrollToElement(element: HTMLElement, position: ScrollLogicalPosition = 'start'): void {
		if (!element) {
			return;
		}
		setTimeout(this.scrollIntoView.bind(this, element, position));
	}

	private scrollIntoView(element: HTMLElement, position: ScrollLogicalPosition): void {
		element.scrollIntoView({
			behavior: 'smooth',
			block: position,
		});
	}
}
